/* eslint-disable guard-for-in */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Card,
  Checkbox,
  CardContent,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import userServices from '../../../../redux/services/userServices';
import ProfessionalNeeds from './ProfessionalNeeds';
import InterestsNeeds from './InterestsNeeds';
import WorkNeeds from './WorkNeeds';

const useStyles = makeStyles((theme) => ({
  row: {
    alignItems: 'stretch',
  },
  column: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  columnFirst: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  columnWithDivider: {
    paddingRight: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      borderTop: 'none',
      marginTop: 0,
      paddingTop: theme.spacing(1),
      borderLeft: `1px solid ${theme.palette.divider}`,
      paddingLeft: theme.spacing(2),
    },
  },
  columnTitle: {
    marginBottom: theme.spacing(2.5),
    marginTop: theme.spacing(2),
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
}));

const NeedsSelection = ({
  group,
  vocPro,
  setVocPro,
  vocInterests,
  setVocInterests,
  vocWork,
  setVocWork,
}) => {
  const classes = useStyles();
  const [globalNeeds, setGlobalNeeds] = useState({
    logistics: 0,
    sales: 0,
    marketing: 0,
    hr: 0,
    finance: 0,
    legal: 0,
    engineering: 0,
    production: 0,
    quality: 0,
    it: 0,
    otherPro: 0,
    news: 0,
    environment: 0,
    economy: 0,
    politics: 0,
    art: 0,
    sport: 0,
    travelling: 0,
    education: 0,
    leisure: 0,
    otherVoc: 0,
    meetings: 0,
    presentations: 0,
    negotiations: 0,
    emails: 0,
    telephoning: 0,
    otherWorksRelated: 0,
    disability: 0,
  });

  useEffect(async () => {
    if (group && group._id) {
      const res = await userServices.getStudentByGroup(group._id);
      if (res !== undefined && res !== null && res.length > 0) {
        // setStudentsList(res);
        let globalNeedsObj = { ...globalNeeds };
        res.forEach((student) => {
          if (student.needs) {
            for (const need in student.needs) {
              for (const item in globalNeedsObj) {
                if (item === need && student.needs[need]) {
                  globalNeedsObj = { ...globalNeedsObj, [item]: globalNeedsObj[item] += 1 };
                }
              }
            }
          }
        });
        setGlobalNeeds(globalNeedsObj);
      }
    }
  }, [group]);

  return (
    <Card style={{ marginBottom: '20px', marginTop: '20px' }}>
      <CardContent>
        <Grid container className={classes.row}>
          <Grid item xs={12} md={3} className={`${classes.column} ${classes.columnFirst}`}>
            <Typography variant="body1" className={classes.columnTitle}>
              Professional/technical vocabulary
            </Typography>
            <ProfessionalNeeds vocPro={vocPro} setVocPro={setVocPro} globalNeeds={globalNeeds} />
          </Grid>
          <Grid item xs={12} md={3} className={`${classes.column} ${classes.columnWithDivider}`}>
            <Typography variant="body1" className={classes.columnTitle}>
              General vocabulary
            </Typography>
            <InterestsNeeds vocInterests={vocInterests} setVocInterests={setVocInterests} globalNeeds={globalNeeds} />
          </Grid>
          <Grid item xs={12} md={3} className={`${classes.column} ${classes.columnWithDivider}`}>
            <Typography variant="body1" className={classes.columnTitle}>
              Professional skills
            </Typography>
            <WorkNeeds vocWork={vocWork} setVocWork={setVocWork} globalNeeds={globalNeeds} />
          </Grid>
          <Grid item xs={12} md={3} className={`${classes.column} ${classes.columnWithDivider}`}>
            <Typography variant="body1" className={classes.columnTitle}>
              Disability needs
            </Typography>
            <FormGroup>
              <FormControlLabel
                disabled
                control={(
                  <Checkbox
                    checked={globalNeeds.disability > 0}
                    color="primary"
                  />
                )}
                label={`disability (${globalNeeds.disability})`}
              />
            </FormGroup>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default NeedsSelection;
